import * as yup from 'yup';
import { eTagType } from '../../types/tags/eTagType';
import { ITagData } from '../../types/tags/ITagData';

export const generateEditTagScheme = (allTags: ITagData[], thisTagLabel: string) => {
  const tagLabels: Set<string> = new Set(allTags.map((tag) => tag.label).filter((label) => label !== thisTagLabel));
  return yup.object({
    label: yup
      .string()
      .test({
        name: 'Label uniqueness',
        message: 'The name of this tag must be unique.',
        test: (value = '') => !tagLabels.has(value),
      })
      .required(),
    type: yup.mixed<eTagType>().required(),
    isActive: yup.boolean().required(),
  });
};
